import { request } from '@@/plugin-request';

const DEFAULT_RENDER_TIMEOUT_MS = 90 * 1000;

async function postRenderJson(serverAddr, path, data, { responseType = 'json' } = {}) {
  const controller = typeof AbortController === 'undefined' ? null : new AbortController();
  const timeoutId = controller
    ? setTimeout(() => {
        controller.abort();
      }, DEFAULT_RENDER_TIMEOUT_MS)
    : null;

  try {
    const response = await fetch(`${serverAddr}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
      signal: controller?.signal,
    });

    if (!response.ok) {
      const errorText = await response.text().catch(() => '');
      throw new Error(errorText || `Render request failed with status ${response.status}`);
    }

    if (responseType === 'blob') {
      return response.blob();
    }

    return response.json();
  } catch (error) {
    if (error.name === 'AbortError') {
      throw new Error('生成服务请求超时，请重试');
    }
    throw error;
  } finally {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  }
}

export async function createOperationKuaKuaBonus(payload) {
  return request('/api/wechat/operation/kuaKuaBonus', {
    method: 'POST',
    data: payload,
  });
}

//verifyErpUser
export async function verifyErpUser(payload) {
  return request('/api/wechat/verifyErpUser', {
    method: 'POST',
    data: payload,
  });
}

//getHeadTeachers
export async function getHeadTeachers(params) {
  return request('/api/wechat/headTeachers', {
    method: 'GET',
    params,
  });
}

export async function getHeadTeacherStudent(params) {
  return request('/api/wechat/headTeacherStudent', {
    method: 'GET',
    params,
  });
}

export async function getAllSales(params) {
  return request('/api/wechat/sales', {
    method: 'GET',
    params,
  });
}

export async function getConsultants(params) {
  return request('/api/wechat/consultant', {
    method: 'GET',
    params,
  });
}

export async function getUploadParams(params) {
  return request('/api/wechat/upload', {
    method: 'GET',
    params,
  });
}

//生成关联二维码
export async function generateRelationQrCode(params) {
  return request('/api/wechat/generateWechatQrCode', {
    method: 'GET',
    params,
  });
}

export async function sendKuakuaBonusMessageToLark(body) {
  return request('/api/wechat/sendKuakuaBonusMessageToLark', {
    method: 'POST',
    data: body,
  });
}

export async function resendKuakuaBonusMessageToLark(body) {
  return request('/api/wechat/resendKuakuaBonusMessageToLark', {
    method: 'POST',
    data: body,
  });
}

export async function getMonthlyKuakuaBonusData(body) {
  return request('/api/wechat/monthlyKuakuaBonusData', {
    method: 'POST',
    data: body,
  });
}

export async function getSalesByTeam(params) {
  return request('/api/users/salesByTeam', {
    method: 'GET',
    params,
  });
}

export async function createSalesBonus(body) {
  return request('/api/salesBonus', {
    method: 'POST',
    data: body,
  });
}

export async function previewMonthlyKuakua(serverAddr, data) {
  return postRenderJson(serverAddr, '/monthlyKuakuaTable/preview', data);
}

export async function generateMonthlyKuakua(serverAddr, data) {
  return postRenderJson(serverAddr, '/monthlyKuakuaTable/generate', data, {
    responseType: 'blob',
  });
}

export async function previewMentorOperationsResultTable(serverAddr, data) {
  return postRenderJson(serverAddr, '/mentorOperationsResultTable/preview', data);
}
